const CardBase = require("./card-base.js");

class CardSlider extends CardBase {
    static type() {
        return "cardslider";
    }
}

module.exports = CardSlider;